import { isTestMode } from "dashboard-utils";

export const ENV = {
    DEV: "DEV",
    STAGING: "STAGING",
    UAT: "UAT",
    PROD: "PROD"
};

export const MERCHANT_SESSION = {
    LIVE: 'live',
    TEST: 'test'
}


export const getCurrentMode = () => {
    try {
        if( process?.env?.CURRENT_ENV == ENV.PROD ) {
            if(isTestMode) return Modes.TEST;
            return Modes.LIVE;
        } else if( process?.env?.CURRENT_ENV == ENV.UAT ) {
            return Modes.TEST;
        }
    } catch(e) {
        console.log(e);
    }

    return null;
}